<template>
  <div class="container-sms-log" :class="{loading: loading}">
    <nav class="nav-header">
      <p
        @click="$router.push({name: 'company-admin-sms-log-list-incoming'})"
        :class="($route.name === 'company-admin-sms-log-list-incoming') ? 'active' : ''"
      >Incoming</p>
      <p
        @click="$router.push({name: 'company-admin-sms-log-list-outgoing'})"
        :class="($route.name === 'company-admin-sms-log-list-outgoing') ? 'active' : ''"
      >Outgoing</p>
    </nav>
    <router-view @loading="setClass" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    setClass(l) {
      this.loading = l;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-sms-log {
  padding: 0 20px;

  &.loading {
    overflow: hidden;
  }
}
.container-sms-log .nav-header {
  margin: 0 -20px;
}
.container-sms-log {
  .nav-header {
    height: 50px;
    background-color: #fff;
    padding: 0px 10px 0px 10px;
    display: flex;
    p {
      cursor: pointer;
      height: calc(100% - 2px);
      display: flex;
      align-items: center;
      padding: 0px 5px 0px 5px;
      margin-right: 10px;
      color: #bdbfd8;
      font-family: "" Helvetica Neue "";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
  }
}
</style>
